import React, { useEffect, useState } from 'react'
import { Tabs, Collapse } from 'antd'
import { ToolOutlined, BulbOutlined, FileTextOutlined } from '@ant-design/icons'
import axios from 'axios'
import 'src/Pages/LibraryPages/librarypages.scss'

const { TabPane } = Tabs
const { Panel } = Collapse

const ACCENTS = ['a-blue', 'a-cyan', 'a-teal', 'a-amber', 'a-emerald', 'a-sky', 'a-navy']

const LibraryIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 3 2 8l10 5 10-5-10-5Z" />
    <path d="M2 16l10 5 10-5" />
    <path d="M2 12l10 5 10-5" />
  </svg>
)

const ProjectIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M3 12h18" />
  </svg>
)

const ProjectLibrary = () => {
  const token = localStorage.getItem('token')
  const [projects, setProjects] = useState([])
  const [framework, setFramework] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL_API}/InternshipProject/Library/Mentor`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: '*/*',
            },
          },
        )
        setProjects(response.data.projects || [])
        setFramework(response.data.projectFramework || [])
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  return (
    <div className="lpg">
      <div className="lpg__head">
        <div className="lpg__head-main">
          <span className="lpg__head-ic">
            <LibraryIcon />
          </span>
          <div>
            <h1 className="lpg__title">Project Library</h1>
            <p className="lpg__sub">Browse project resources and the execution framework.</p>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="lpg__state">
          <div className="lpg__spin" />
          Loading...
        </div>
      ) : (
        <div className="lpg__panel-box">
          <Tabs defaultActiveKey="1">
            <TabPane tab="Library's Projects" key="1">
              <h3>Library&apos;s Projects List</h3>
              {projects.length === 0 ? (
                <div className="lpg__empty-row">No projects in the library yet.</div>
              ) : (
                <div className="lpg__grid">
                  {projects.map((project, index) => (
                    <div
                      key={index}
                      className={`lpg__card ${ACCENTS[index % ACCENTS.length]}`}
                      style={{ cursor: 'default' }}
                    >
                      <span className="lpg__ic">
                        <ProjectIcon />
                      </span>
                      <span className="lpg__ct">{project.title}</span>

                      <div
                        style={{
                          width: '100%',
                          maxHeight: 200,
                          overflowY: 'auto',
                          display: 'grid',
                          gap: 10,
                        }}
                      >
                        <div>
                          <div className="lpg__label">
                            <FileTextOutlined /> Description
                          </div>
                          <div className="lpg__cd">{project.description}</div>
                        </div>

                        <div>
                          <div className="lpg__label">
                            <BulbOutlined /> Skills Learned
                          </div>
                          <div className="lpg__cd">{project.skillsLearned.join(', ')}</div>
                        </div>

                        <div>
                          <div className="lpg__label">
                            <ToolOutlined /> Tools
                          </div>
                          <div className="lpg__cd">{project.tools.join(', ')}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </TabPane>

            <TabPane tab="Project Framework" key="2">
              <h3>Project Execution Framework</h3>
              {framework.length === 0 ? (
                <div className="lpg__empty-row">No framework steps available yet.</div>
              ) : (
                <Collapse accordion>
                  {framework.map((step, index) => (
                    <Panel header={step.title} key={index}>
                      <ul>
                        {step.tasks.map((task, i) => (
                          <li key={i}>{task}</li>
                        ))}
                      </ul>
                    </Panel>
                  ))}
                </Collapse>
              )}
            </TabPane>
          </Tabs>
        </div>
      )}
    </div>
  )
}

export default ProjectLibrary
